// Substitua pelo link real do seu checkout (Hotmart, Kiwify etc.) e pelo preço final.
export const CHECKOUT_URL = "https://pay.kiwify.com.br/IzNADS3";
export const PRICE = "R$ 19,90";

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
